import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Determine if we're on the homepage or not
  const isHomePage = window.location.pathname === '/';
  // Remove Topics and Experience from both desktop and mobile navigation
  const desktopNavItems = isHomePage ? ['About', 'Agenda', 'Register', 'Sponsorship'] : ['Home', 'Sponsorship'];
  // Mobile navigation items - same as desktop now
  const mobileNavItems = isHomePage ? ['About', 'Agenda', 'Register', 'Sponsorship'] : ['Home', 'Sponsorship'];
  const getNavLink = (item: string) => {
    if (item === 'Home') return '/';
    if (item === 'Sponsorship') return '/sponsorship';
    return `#${item.toLowerCase()}`;
  };
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, item: string) => {
    if (isHomePage && item !== 'Sponsorship') {
      e.preventDefault();
      const element = document.getElementById(item.toLowerCase());
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      setIsMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-81">
      <div className="container mx-auto px-4 md:px-6" data-id="element-82">
        <div className="flex items-center justify-between" data-id="element-83">
          <div className="flex items-center" data-id="element-84">
            <Link to="/" data-id="element-85">
              <h1 className={`text-xl font-bold ${isScrolled ? 'text-black' : 'text-white'}`} data-id="element-86">
                COMMERCE CFO ROUNDTABLE 2025
              </h1>
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-87">
            {desktopNavItems.map(item => <Link key={item} to={getNavLink(item)} onClick={e => handleNavClick(e, item)} className={`font-medium hover:text-red-600 transition-colors ${isScrolled ? 'text-gray-800' : 'text-white'}`} data-id="element-88">
                {item}
              </Link>)}
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-89">
            {isMenuOpen ? <X className={isScrolled ? 'text-black' : 'text-white'} size={24} data-id="element-90" /> : <Menu className={isScrolled ? 'text-black' : 'text-white'} size={24} data-id="element-91" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden absolute left-0 right-0 top-full bg-white shadow-md p-4" data-id="element-92">
            <div className="flex flex-col space-y-4" data-id="element-93">
              {mobileNavItems.map(item => <Link key={item} to={getNavLink(item)} onClick={e => handleNavClick(e, item)} className="text-gray-800 font-medium hover:text-red-600 transition-colors" data-id="element-94">
                  {item}
                </Link>)}
            </div>
          </div>}
      </div>
    </header>;
}